import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import HorizontalLayoutContainer from '../publicLayout/components/HorizontalLayoutContainer';
import { H2 } from 'foundations-components/transitional/components/H2';
import { H4 } from 'foundations-components/transitional/components/H4';
import { Box } from 'foundations-components/transitional/components/Box';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { NextIcon, DesktopIcon, LessonIcon, CertificationIcon } from 'foundations-assets';
import FormattedMessage from 'I18n/components/FormattedMessage';
import usageTracker from '../../utils/usageTracker';
import { getSignupCtaHref } from '../../utils/urls';
import StyledSection from '../publicLayout/components/StyledSection';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { ThemedPrimaryButton } from '../../components/ThemedComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SIGNUP_CTA_ID = 'certifications-overview-bottom';
const PROCESS_STEPS = [{
  icon: DesktopIcon,
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.certificationsProcessSection.stepOneTitle"
  }),
  description: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.certificationsProcessSection.stepOneDescription"
  })
}, {
  icon: LessonIcon,
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.certificationsProcessSection.stepTwoTitle"
  }),
  description: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.certificationsProcessSection.stepTwoDescription"
  })
}, {
  icon: CertificationIcon,
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.certificationsProcessSection.stepThreeTitle"
  }),
  description: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.certificationsProcessSection.stepThreeDescription"
  })
}];
const ProcessItem = ({
  icon,
  title,
  description,
  isTablet
}) => {
  return /*#__PURE__*/_jsxs(Box, {
    flexBasis: isTablet ? '0' : '300px',
    maxInlineSize: "300px",
    paddingBlockStart: "200",
    children: [/*#__PURE__*/_jsx(View, {
      as: "div",
      marginBlockEnd: "300",
      children: /*#__PURE__*/_jsx(IconHolder, {
        icon: icon,
        padding: "0",
        size: "900"
      })
    }), /*#__PURE__*/_jsx(H4, {
      children: title
    }), /*#__PURE__*/_jsx("p", {
      children: description
    })]
  });
};
const ProcessArrow = ({
  isTablet
}) => {
  return /*#__PURE__*/_jsx(IconHolder, {
    alignSelf: isTablet ? 'center' : 'start',
    color: "icon-core-on-fill-default",
    icon: NextIcon,
    marginBlockStart: isTablet ? '0' : '400',
    padding: "0",
    rotate: isTablet ? 90 : 0,
    rotateLock: true,
    size: "800"
  });
};
const CertificationProcessSection = () => {
  const {
    isTablet
  } = useMediaQuery();
  const handleSignupCtaClick = hubsSignupCta => {
    usageTracker.track('interaction', {
      action: 'signup-button-click',
      value: hubsSignupCta
    });
  };
  return /*#__PURE__*/_jsx(View, {
    textAlign: "center",
    children: /*#__PURE__*/_jsx(StyledSection, {
      backgroundColor: "do-not-use-heffalump",
      textColor: "text-core-on-fill-default",
      children: /*#__PURE__*/_jsxs(HorizontalLayoutContainer, {
        children: [/*#__PURE__*/_jsx(H2, {
          marginBlockEnd: "1200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.certificationsProcessSection.title"
          })
        }), /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          flexDirection: isTablet ? 'column' : 'row',
          gap: "200",
          justifyContent: "center",
          marginBlockEnd: "1200",
          padding: "0",
          children: PROCESS_STEPS.map((step, index) => /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(ProcessItem, {
              description: step.description,
              icon: step.icon,
              isTablet: isTablet,
              title: step.title
            }, index), index < PROCESS_STEPS.length - 1 && /*#__PURE__*/_jsx(ProcessArrow, {
              isTablet: isTablet
            })]
          }))
        }), /*#__PURE__*/_jsx(ThemedPrimaryButton, {
          href: getSignupCtaHref(SIGNUP_CTA_ID),
          onClick: () => handleSignupCtaClick(SIGNUP_CTA_ID),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.certificationsProcessSection.signUpCta"
          })
        })]
      })
    })
  });
};
export default CertificationProcessSection;